module.exports = __webpack_public_path__ + "static/feature-network-3fb6a702837ca8e32dcd0891a1f50fb6.png";